import { render, staticRenderFns } from "./nav-tags.vue?vue&type=template&id=448b1fc0&scoped=true"
import script from "./nav-tags.vue?vue&type=script&lang=js"
export * from "./nav-tags.vue?vue&type=script&lang=js"
import style0 from "./nav-tags.vue?vue&type=style&index=0&id=448b1fc0&prod&lang=less&scoped=true"
import style1 from "./nav-tags.vue?vue&type=style&index=1&id=448b1fc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448b1fc0",
  null
  
)

export default component.exports